<template>
  <section class="row no-gutters p-0 bg-light min-vh-100">
    <div class="col-lg-6 d-none d-lg-block order-lg-2">
      <div class="divider divider-side bg-light transform-flip-y d-none d-lg-block"></div>
      <img class="flex-fill" src="../../assets/jumpstart/img/heros/hero-2.jpg" alt="Image">
    </div>
    <div class="col-lg-6">
      <section class="p-0">
        <div class="container min-vh-lg-100 d-flex flex-column justify-content-between text-center py-4 py-md-5">
          <a href="https://www.hostomate.com" class="fade-page">
            <img width="180" src="../../assets/jumpstart/img/logos/hostomate.svg" alt="Hostomate">
          </a>
          <div class="row justify-content-center my-5">
            <router-view></router-view>
          </div>
          <div>
            <a href="https://www.hostomate.com" class="btn btn-sm btn-outline-primary fade-page">Domov</a>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import '../../assets/jumpstart/css/main.css';

export default {
  name: 'Auth',
  created(){
    require('../../assets/jumpstart/css/main.css')
  },
  destroyed(){
  },
  methods: {
    /*login: function(payload){
      return fetch( process.env.VUE_APP_API + '/login', {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
    }*/
    login: function(payload){
      return fetch( process.env.VUE_APP_API + '/auth/refresh', {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
    }
  }
}
</script>
